import { render, staticRenderFns } from "./SearchableDocumentsListNew.vue?vue&type=template&id=0eac0c5a"
import script from "./SearchableDocumentsListNew.vue?vue&type=script&lang=ts"
export * from "./SearchableDocumentsListNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eac0c5a')) {
      api.createRecord('0eac0c5a', component.options)
    } else {
      api.reload('0eac0c5a', component.options)
    }
    module.hot.accept("./SearchableDocumentsListNew.vue?vue&type=template&id=0eac0c5a", function () {
      api.rerender('0eac0c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/SearchableDocumentsListNew.vue"
export default component.exports